import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { ERROR_MESSAGES } from '../constants/error-message.constants';
import { LoggerService } from './logger.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private logger : LoggerService, private notificationService : NotificationService) { }

  private extractHttpErrorMessage(error: HttpErrorResponse): string {
    try {
      const err: any = error as any;
      const payload = err?.error;

      if (typeof payload === 'string' && payload.trim()) return payload;
      if (payload?.message) return String(payload.message);

      const responsemsg = payload?.responsemsg;
      if (Array.isArray(responsemsg) && responsemsg.length) {
        const descs = responsemsg
          .map((e: any) => (typeof e?.desc === 'string' && e.desc.trim()) ? e.desc : e?.code)
          .filter((d: any) => typeof d === 'string' && d.trim());
        if (descs.length) return descs.join('\n');
      }

      if (error?.status) {
        return `Request failed with status ${error.status}${error.statusText ? ` (${error.statusText})` : ''}.`;
      }
    } catch {}
    return 'Request failed.';
  }

  handleError(error: any, optionsMessage?: string) {
    // Handle different error types
    if (error instanceof HttpErrorResponse) {
      
      // Handle HTTP errors
      const additionalInfo = optionsMessage ? optionsMessage : 'HTTP error:'
      this.logger.debug(additionalInfo, error);
      
      // Handle HTTP errors with 401
      if(error?.status == 401){
        this.notificationService.alert('error', "Error:401", ERROR_MESSAGES.ERROR_401);
      }else if(error?.status == 504){
        this.notificationService.alert("error", "Error:504", ERROR_MESSAGES.ERROR_504);
      }else if(error?.status == 500){
        this.notificationService.alert("error", "Error:500", ERROR_MESSAGES.ERROR_500);
      }else if(error?.status == 502){
        this.notificationService.alert("error", "Error:502", ERROR_MESSAGES.ERROR_502);
      }else if(error?.status == 0){
        this.notificationService.alert("error", "Error:0", ERROR_MESSAGES.ERROR_0);
      }else if(error?.status == 406){
        // 406 body shape varies (string, missing responsemsg, missing desc, etc.).
        // Use the shared extractor so a malformed body can't crash this branch and
        // fall through to the component's raw `error.message`.
        const message = this.extractHttpErrorMessage(error);
        this.notificationService.alert("error", "Error:406", message);
      }else if(error?.status === 400 && (error?.url?.includes('/nevvon') || error?.url?.includes('/mobilehealth'))) {
        // No alert if backend Nevvon or Mobile Health calls fail with Bad Request
        return;
      }else{
        const message = this.extractHttpErrorMessage(error);
        this.notificationService.alert("error", `Error:${error?.status ?? ''}`.replace(/:$/, ''), message);
      }

    } else if (error instanceof Error) {
      
      // Handle other errors
      const additionalInfo = optionsMessage ? optionsMessage : 'Application error:'
      this.logger.debug(additionalInfo, error);
    
    } else {
    
      // Handle unknown error types
      const additionalInfo = optionsMessage ? optionsMessage : 'Unknown error:'
      this.logger.debug(additionalInfo, error);
    
    }
  }
}
